
























































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import ProductBase from '@/components/Products/ProductBase';

import ProductCard from '@/components/Products/ProductCard.vue';

@Component({
    components: {
        ProductCard
    }
})
export default class ProductCardProfessionalPromo1 extends ProductBase {

    // Member:
    public productKey = 'professional-m-promo-1';

    // Properties:
    @Prop({ required: false, default: 'card' })
    public variant?: 'card' | 'tile';

    // Getter:
    public get priceBegin(): number {
        return 11.90;
    }


    public get price(): number {
        return this.product.object?.price ?? 29.75;
    }

    // Lifecycle Methods:
    public async created() {
        await this.loadProduct(this.productKey);
    }
}
